import React from 'react';
import styled from 'styled-components';
import { Popup } from 'tdesign-react';
import SvgIcon from '@/components/SvgIcon';

/**
 * 跳转链接专用
 */
export default function PopupLink({ children, onClick, tip, ...others }) {
  return (
    <Root {...others}>
      <span style={{ paddingRight: 4 }}>{children}</span>
      <Popup showArrow content={tip}>
        <Container onClick={onClick} className='icon-container'>
          <Icon size={15} type='arrow-circle-right' />
        </Container>
      </Popup>
    </Root>
  );
}

const Root = styled.div`
  display: inline-block;
  word-break: break-all;
`;

const Icon = styled(SvgIcon)`
  color: #194dff;
`;

const Container = styled.div`
  display: inline-block;
  cursor: pointer;
  padding: 3px;
  vertical-align: 1px;
`;
